export default "__VITE_ASSET__807fdd37__"